<div id="layout-wrapper">
  <app-horizontaltopbar (mobileMenuButtonClicked)="onToggleMobileMenu()"
    (settingsButtonClicked)="onSettingsButtonClicked()"></app-horizontaltopbar>

  <div class="main-content" style="background-color: #d5e2f8;">
    <div class="page-content" style="background-color: #d5e2f8;">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer></app-footer>
  <app-rightsidebar></app-rightsidebar>
</div>